import { Link, type LinkProps } from "@mui/material";
import type React from "react";

export const BaseLink: React.FC<LinkProps> = (props) => {
  const { sx, ...rest } = props;
  return (
    <Link
      target="_blank"
      {...rest}
      sx={{
        color: "#1364C0",
        ...sx,
      }}
    />
  );
};
